import { EthereumMap } from "./etheriumAction";

const InitState = {
    fetching: false,
    address: "",
    web3: null,
    web3Modal: null,
    provider: null,
    connected: false,
    chainId: 4,
    networkId: 4,
}

const etheriumReducer = (state = InitState, action) => {
    switch (action.type) {
        case EthereumMap.ACCOUNT_CONNECTED_SUCCESS: {
            const { payload } = action;
            return {
                ...state,
                connected: payload.connected,
                address: payload.address,
                chainId: payload.chainId,
                networkId: payload.networkId,
                provider: payload.provider,
                web3: payload.web3,
                web3Modal: payload.web3Modal,
            };
        }
        case EthereumMap.ACCOUNT_CONNECTED_ERROR: {
            return {
                fetching: false,
                address: "",
                web3: null,
                provider: null,
                connected: false,
                chainId: 1,
                networkId: 1,
                showModal: false,
                pendingRequest: false,
                result: null,
            };
        }
        case EthereumMap.RESET_APP: {
            return {
                fetching: false,
                address: "",
                web3: null,
                web3Modal: null,
                provider: null,
                connected: false,
                chainId: 1,
                networkId: 1,
                showModal: false,
                pendingRequest: false,
                result: null,
            };
        }
        case EthereumMap.ACCOUNTS_CHANGED_SUCCESS: {
            return {
                ...state,
                address: action.payload.address,
            };
        }
        case EthereumMap.CHAIN_CHANGED_SUCCESS: {
            return {
                ...state,
                chainId: action.payload.chainId,
                networkId: action.payload.networkId,
            };
        }
        case EthereumMap.NETWORK_CHANGED_SUCCESS: {
            return {
                ...state,
                chainId: action.payload.chainId,
                networkId: action.payload.networkId,
            };
        }
        case EthereumMap.LOADER_SUCCESS: {
            return {
                ...state,
                fetching: action.payload,
            };
        }
       
        default: return { ...state }
    }
}

export default etheriumReducer;